import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

export function runApp() {
  const store = createApplicationState();

  renderApplication({ store });
}
